const Inventors = Vue.component('inventors', {
    template: `
        <div>
            <div class="row title">
                <div class="col">
                    <h4>
                        {{ $language.familyNum.replace('[FAMILYNUMBER]', family) }}&nbsp;<i class="fas fa-angle-right"></i>&nbsp;{{ $language.inventors }}
                    </h4>
                </div>
            </div>
            <div class="main" id="inventors">
                <div class="col-12 tuto">
                    {{ $language.clickInv }}
                </div>
                <div class="row links" v-if="$store.state.inventors.length > 0">
                    <div class="col-12 col-lg-8">
                        <div class="row">
                            <div class="col-12 link" v-for="inventor in $store.state.inventors" v-if="inventor">
                                <router-link :to="'/' + family + '/inventors/' + inventor">
                                    {{ inventor }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    {{ $language.invNotFound }}
                </div>
            </div>
        </div>
    `,

    computed: {
        family() {
            return this.$route.params.family;
        }
    },
    data: function() {
        return {};
    },

    mounted: function() {
        this.$store.commit('addLoadedComponent', 'Inventors');

        this.getInventors();

        EventBus.$on('newFamily', () => {
            this.getInventors();
        });

    },

    methods: {

        getInventors() {

            axios.get('?page=getData&action=inventors', {
                    params: {
                        family: this.family
                    }
                })
                .then(response => {
                    this.$store.commit('saveInventors', response.data);
                    this.$store.commit('hideLoading');
                })
                .catch(err => {
                    console.log(err);
                });
        },

    }
});
